<!--
  * @Author: changyunxia
  * @Date:2020年10月15日 16:25:03
  * @LastEditors: changyunxia
  * @LastEditTime: @Date:2020年10月15日 16:25:03
  * @Description: 添加参会人  tree
  * @FilePath:@/components/getNeetingUsers.vue
-->
<template>
  <div>
    <van-nav-bar
      title="选择参会人"
      left-text="取消"
      right-text="确定"
      left-arrow
      fixed
      @click-left="onCancel"
      @click-right="onClickRight"
    />
    <div class="pdc">
      <van-search
        v-model="searchWord"
        class="search"
        show-action
        placeholder="请输入搜索关键词"
      />
    </div>

    <div class="pdc">
      <meetingUserList :plus="false" :close="true" :user-list="currentData" @delFunc="delFunc" />
      <div v-if="filteredSearchWord.length>0" class="content">
        <van-cell v-for="(item,index) in filteredSearchWord" :key="index" :title="item.text" @click="clickItem(item)" />
      </div>
      <el-tree
        v-else
        ref="tree"
        :data="department"
        :props="defaultProps"
        accordion
        node-key="value"
        :default-expanded-keys="expandedKeys"
        :default-checked-keys="defaultkeysData"
        :show-checkbox="true"
        @node-click="handleNodeClick"
        @check="handlecurrentClick"
      />
    </div>

  </div>
</template>

<script>
import meetingUserList from '@/components/MeetingReservation/meetingUserList'
// department
export default {
  name: 'GetNeetingUsers',
  components: { meetingUserList },
  props: {
    department: {
      type: Array,
      default: null
    },
    userList: {
      type: Array,
      default: null
    },
    allUsers: {
      type: Array,
      default: null
    }
  },
  data() {
    return {
      searchWord: '',
      searchWordSgow: false,
      currentData: [],
      defaultProps: {
        // child: 'children',
        label: 'text'
      },
      defaultkeysData: [],
      expandedKeys: ['0000000000']
    }
  },
  computed: {
    // 计算数学，匹配搜索
    filteredSearchWord: {
      get: function() {
        var arr = []
        if (this.searchWord !== '') {
          const arr1 = this.uniquelist(this.allUsers)
          arr = arr1.filter(value => value.text.indexOf(this.searchWord) !== -1)
        }
        return arr
      },
      set: function() {}

    }
  },
  watch: {},
  created() {
  },
  mounted() {
    if (this.userList.length > 0) {
      const users = this.userList
      this.currentData = users
      const arr = []
      // 设置默认展开值
      this.userList.forEach(element => {
        arr.push(element.value)
      })
      this.defaultkeysData = arr
    }
  },
  methods: {
    uniquelist(arr) {
      const res = new Map()
      return arr.filter((arr) => !res.has(arr.value) && res.set(arr.value, 1))
    },
    // 默认选择
    setDefaultChecked() {
      this.$nextTick(() => {
        this.$refs.Tree.setCheckedKeys(this.CheckedArr) // CheckedArr 一个选中的数组element Ui的东西，关键是看$nextTick的用法
      })
    },
    delFunc(val) {
      const arr = []
      this.currentData.forEach((item, i) => {
        if (item.value !== val.value) {
          arr.push(item.value)
        }
      })
      this.$nextTick(function() {
        this.$refs.tree.setCheckedKeys(arr)
      })
    },
    clickItem(data) {
      this.currentData.push(data)
      var key = []

      const obj = {}
      // 去重
      const peon = this.currentData.reduce((cur, next) => {
        obj[next.value] ? '' : obj[next.value] = true && cur.push(next)
        return cur
      }, []) // 设置cur默认类型为数组，并且初始值为空的数组

      peon.forEach(element => {
        key.push(element.value)
        this.expandedKeys.push(element.department)
      })
      this.defaultkeysData = key
      this.searchWord = ''
    },
    onCancel() {
      this.$emit('update:showPicker', false)
    },
    onClickRight() {
      this.$emit('update:showPicker', false)
      this.$emit('checkedNodes', this.currentData)
    },
    // 选中的参会人
    handlecurrentClick(data, val, t) {
      this.currentData = []
      var valuelist = []
      const list = val.checkedNodes
      list.forEach(element => {
        console.log(element.value)
        if (!element.children) {
          valuelist.push(element)
        }
      })
      const arr1 = this.unique(valuelist)
      this.currentData = arr1
    },
    unique(arr) {
      const res = new Map()
      return arr.filter((arr) => !res.has(arr.id) && res.set(arr.id, 1))
    },
    handleNodeClick(data) {
      // console.log(data)
    },
    recursion(data, current) {
      var result = null
      if (!data) {
        // return; 中断执行
        return
      }
      for (var i in data) {
        var item = data[i]
        if (item.value === current) {
          result = item
          break
        } else if (item.children && item.children.length > 0) {
          result = this.recursion(item.children, current)
        }
      }
      return result
    }
  }
}
</script>
<style lang='scss' scoped>
//@import url(); 引入公共css类
/deep/.el-tree-node__content{
    position: relative;
}
/deep/.el-tree-node__content>label.el-checkbox {
    margin-right: 8px;
    position: absolute;
    right: 0;
}
/deep/.van-nav-bar--fixed {
    z-index: 99;
}
.pdc{
  padding-top:45px;
}
/deep/.van-search{
padding: 0 12px;
}
.search {
  position: fixed;
  z-index: 2;
  width: 100vw;
  padding-top: 5px;
}
</style>
